import { Injectable } from '@angular/core';
import { fromEvent, merge, Subject } from 'rxjs';
import { share } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class EventsService {
  readonly doResize = new Subject();

  readonly resize = merge(this.doResize, fromEvent(window, 'resize')).pipe(
    share(),
  );
}
